import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Header from "../../Header";
import Sidebar from "../../Sidebar";
import Footer from "../../Footer";
import UsersDetails from "./UsersDetails";

const Users = () => {
    return (
        <>
            <div className="container-scroller">
                <Header />
                <div className="container-fluid page-body-wrapper">
                    <Sidebar />
                    <Box component="main" className="main-panel" sx={{ display: "flex", flexDirection: "column" }}>
                        <Box sx={{ flex: 1, py: { xs: 2, md: 3 } }}>
                            <Container maxWidth="xl" disableGutters sx={{ px: { xs: 2, md: 3 } }}>
                                <UsersDetails from={"users"} organizationId={null} />
                            </Container>
                        </Box>
                        <Footer />
                    </Box>
                </div>
            </div>
        </>
    );
};

export default Users;
